module.exports = __webpack_public_path__ + "img/icon.d0289dc0.png";